export const AuthenticationLogin = (data) => ({
    type: 'AuthenticationLogin',
    data: data
});

export const AuthenticationLogout = () => ({
    type: 'AuthenticationLogout'
});
